import { AlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';

export function transformSearchFiltersToQueryParams(
  filters: AlgoliaApiQueryFilters,
) {
  // Remove 'type' since we're handling it separately
  const { type, ...otherFilters } = filters;

  // Convert the filters into URL-friendly format
  return Object.entries(otherFilters).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: Array.isArray(value) ? value.join(`&${key}=`) : value,
    }),
    {},
  );
}
